import { lazy, Suspense } from 'react'

import { LoadingTurbo } from 'atoms'

import { LoginBlockedScreenComponent } from './LoginBlockedScreen.types'
import { useLoginBlockedScreen } from './useLoginBlockedScreen'

const LoginBlockedScreenDesktop = lazy(() => import('./LoginBlockedScreen.desktop'))

const LoginBlockedScreenMobile = lazy(() => import('./LoginBlockedScreen.mobile'))

export const LoginBlockedScreen: LoginBlockedScreenComponent = ({ navigation }) => {
  const loginBlockedScreen = useLoginBlockedScreen({ navigation })

  const Screen = loginBlockedScreen.isMobile ? LoginBlockedScreenMobile : LoginBlockedScreenDesktop

  return (
    <Suspense fallback={<LoadingTurbo />}>
      <Screen {...loginBlockedScreen} />
    </Suspense>
  )
}
